import React from 'react';
import clsx from 'clsx';
import { AlertCircle } from 'lucide-react';
import styles from './ErrorState.module.css';

export interface ErrorStateProps extends React.HTMLAttributes<HTMLDivElement> {
  title?: string;
  message: string;
  icon?: React.ReactNode;
  action?: React.ReactNode;
}

const ErrorState: React.FC<ErrorStateProps> = ({
  title,
  message,
  icon,
  action,
  className,
  ...props
}) => {
  return (
    <div className={clsx(styles.errorContainer, className)} {...props}>
      {icon !== undefined ? icon : <AlertCircle size={48} className={styles.errorMessage} />}
      {title && <h2 className={styles.errorMessage}>{title}</h2>}
      <p className={styles.errorMessage}>{message}</p>
      {action && <div>{action}</div>}
    </div>
  );
};

export default ErrorState;
